<template>
    <section>
        <Drawer v-model:visible="show" :showCloseIcon="true" @hide="emit('closed')" position="left"
            class="w-full max-w-xs bg-[#fffaf4]" :pt="{
                root: { class: 'bg-[#fffaf4] border-r border-[#d8c2ab] shadow-2xl' },
                header: { class: 'bg-[#fffaf4] pt-6 px-6' },
                content: { class: 'bg-[#fffaf4] p-6' }
            }">
            <UserMenuComponent :mobile="true" />
        </Drawer>
    </section>
</template>

<script setup>
import { Drawer } from 'primevue';
import { ref, defineProps, watch, defineEmits } from 'vue';
import UserMenuComponent from '../Header/UserMenuComponent.vue';

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    }
});

const show = ref(false);
watch(() => props.show, (newValue) => {
    show.value = newValue;
}, { immediate: true });

const emit = defineEmits({
    click: null,
    selectedOption: ({ selectedOption }) => selectedOption,
    closed: () => true
});
</script>